import script from "./Forget.vue?vue&type=script&setup=true&lang=js"
export * from "./Forget.vue?vue&type=script&setup=true&lang=js"

import "./Forget.vue?vue&type=style&index=0&id=1606622e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1606622e"]])

export default __exports__